import { VALID_COUNTRY_CODES } from './constants';

import type { CountryCode } from 'libphonenumber-js';

/**
 * Detects the default country code based on the user's locale if auto-detection is enabled.
 * - Falls back to 'US' if the locale country code cannot be determined.
 * - Uses the provided default country code if auto-detection is disabled, falling back to 'US' if it's invalid.
 *
 * @returns The country code (e.g., 'DE', 'US', 'FR')
 */

export const FALLBACK_COUNTRY_CODE: CountryCode = 'US';

const isValidCountryCode = (countryCode: string): boolean => {
    return (
        countryCode.length === 2 &&
        /^[A-Z]{2}$/.test(countryCode) &&
        VALID_COUNTRY_CODES.includes(countryCode as CountryCode)
    );
};

export const getDefaultCountryCode = (
    isAutoDetect: boolean,
    defaultCountryCode: CountryCode,
): CountryCode => {
    if (isAutoDetect) {
        try {
            const locale = Intl.DateTimeFormat().resolvedOptions().locale;
            const parts = locale.split('-');
            const countryCode = parts[parts.length - 1].toUpperCase();

            return isValidCountryCode(countryCode)
                ? (countryCode as CountryCode)
                : FALLBACK_COUNTRY_CODE;
        } catch {
            return FALLBACK_COUNTRY_CODE;
        }
    } else {
        return isValidCountryCode(defaultCountryCode) ? defaultCountryCode : FALLBACK_COUNTRY_CODE;
    }
};
